import React,{useEffect, useState} from "react";
import Recipe from './Recipe';
import './App.css';

const App = () =>{

  const APP_ID = "815e2ea4";
  const APP_KEY = "9b0d4483a0492e13f656dad8f0177a11";

  const [recipes , setRecipes] = useState([]);
  const [search, setSearch] = useState('');
  const [query, setQuery] = useState('chicken');
  
  useEffect(()=>{
    getRecipes();
  
  },[query]); 
  
  const getRecipes = async()=>{
    
    const response = await fetch(`https://api.edamam.com/search?q=${query}&app_id=${APP_ID}&app_key=${APP_KEY}`);
    const data = await response.json();
    setRecipes(data.hits);
    console.log(data.hits);
  }

  const updatesearch = e =>{
    setSearch(e.target.value);
    console.log('search');
  }

  const getSearch = e=> {
    e.preventDefault();
    setQuery(search);
    setSearch('');
  }

  return(
    <div className="App">
      <form onSubmit={getSearch} className="Search_form">
        <input className="Search_bar" type="text" value = {search} onChange={updatesearch} ></input>
        <button  className="Search-Button" type="submit">Search</button>
      </form>
      <div className="recipess">
      {recipes.map(recipe => (
        <Recipe
        key = {recipe.recipe.label} 
        title = { recipe.recipe.label} calories = { recipe.recipe.calories} 
        image ={recipe.recipe.image}   ingredients= {recipe.recipe.ingredients}/>
      ) )}
      </div>
    </div>
  )
}

export default App;
